import React from "react";

import AdminPagination from "../../_shared/ui/AdminPagination";
import TrombinoCard from "./TrombinoCard";
import TrombinosEmptyState from "./TrombinosEmptyState";
import TrombinosSkeletonList from "./TrombinosSkeletonList";

export default function TrombinosList({
  items,
  loading,
  total,
  page,
  totalPages,
  actionId,
  onPageChange,
  onPreview,
  onEdit,
  onToggleVisible,
  onToggleElected,
  onAskDelete,
}) {
  return (
    <section className="mt-5 overflow-hidden rounded-[2rem] border border-slate-200 bg-white shadow-sm dark:border-slate-800 dark:bg-slate-900">
      <div className="border-b border-slate-200 px-4 py-4 dark:border-slate-800 sm:px-5">
        <div className="flex flex-col gap-2 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <h2 className="text-lg font-bold text-slate-950 dark:text-white">
              Liste des profils
            </h2>

            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Gérez les fiches des élus municipaux et des personnels communaux.
            </p>
          </div>

          <p className="text-sm font-bold text-slate-500 dark:text-slate-400">
            Page {page} sur {totalPages}
          </p>
        </div>
      </div>

      {loading ? (
        <TrombinosSkeletonList />
      ) : !items?.length ? (
        <TrombinosEmptyState />
      ) : (
        <div className="grid gap-4 p-4 sm:p-5 xl:grid-cols-2 2xl:grid-cols-3">
          {items.map((item) => (
            <TrombinoCard
              key={item.id}
              item={item}
              actionId={actionId}
              onPreview={onPreview}
              onEdit={onEdit}
              onToggleVisible={onToggleVisible}
              onToggleElected={onToggleElected}
              onAskDelete={onAskDelete}
            />
          ))}
        </div>
      )}

      <AdminPagination
        page={page}
        totalPages={totalPages}
        total={total}
        loading={loading}
        onPageChange={onPageChange}
      />
    </section>
  );
}